export const employmentType = {
    'intern': 'Prácticante'
}

export const workMode = {
    'remote': 'Remoto'
}

export const institutions = [
    "Pontificia Universidad Católica del Perú (PUCP)",
    "Universidad Nacional Mayor de San Marcos (UNMSM)",
    "Universidad Peruana de Ciencias Aplicadas (UPC)",
    "Universidad Tecnológica del Perú (UTP)",
    "Universidad César Vallejo (UCV)",
    "Universidad Nacional de Ingeniería (UNI)",
    "Universidad Nacional del Centro del Perú",
    "Universidad Nacional de San Agustín (UNSA)",
    "Universidad de Piura (UDEP)",
    "Universidad Continental",
    "Universidad Norbert Wiener",
    "Universidad San Ignacio de Loyola",
    "Universidad Ricardo Palma",
    "Universidad Peruana Cayetano Heredia",
    "Universidad Femenina del Sagrado Corazón",
    "Universidad Autónoma del Perú",
    "Universidad Católica Sedes Sapientiae",
    "Cibertec",
    "IPAE Business School",
    "TECSUP",
    "IDAT",
    "Senati",
    "Toulouse Lautrec",
    "Le Cordon Bleu Perú",
    "CEPEA",
    "Instituto de Comercio Exterior (ADEX)",
    "Instituto Técnico de Administración de Empresas (ITAE)"
]

export const techCareers = [
    "Ingeniería de Software",
    "Ciencias de la Computación",
    "Ingeniería Informática",
    "Desarrollo de Software",
    "Sistemas de Información",
    "Tecnologías de la Información",
    "Ingeniería de Sistemas",
    "Programación y Desarrollo Web",
    "Desarrollo Mobile",
    "Backend Development",
    "Frontend Development",
    "Full Stack Development",
    "Base de Datos",
    "Ciberseguridad",
    "Inteligencia Artificial",
    "Computación en la Nube",
    "UX/UI Design",
    "Redes y Telecomunicaciones",
    "Análisis de Datos",
    "DevOps"
];

export const techSkills = [
    // Core programming
    "JavaScript",
    "TypeScript",
    "HTML",
    "CSS",

    // Frontend
    "React",
    "React Native",
    "Vite",
    "Next.js",
    "Tailwind CSS",
    "CSS Modules",
    "Responsive Design",

    // Backend
    "Node.js",
    "Express.js",
    "REST APIs",
    "JWT Authentication",

    // Databases
    "MySQL",
    "PostgreSQL",
    "Supabase",
    "Database Modeling",

    // Tools & Workflow
    "Git",
    "GitHub",
    "Version Control",
    "Agile / Scrum",

    // Testing & Quality
    "Unit Testing",
    "Debugging",

    // DevOps / Cloud (básico)
    "Docker (básico)",
    "CI/CD (básico)",

    // UX / UI (plus)
    "UI Design",
    "UX Fundamentals",

    // Soft skills (importantes)
    "Problem Solving",
    "Teamwork",
    "Communication",
    "Self-learning"
];

export const categoriesProduct = {
    'school': 'Aprendizaje',
    'bussines': 'Negocios',
    'culture': 'Cultura',
    'art': 'Arte',
    'ai': 'Inteligencia Artificial'
}